<template>
  <el-dialog custom-class="lease-repair-form-dialog lease-dialog" :visible="show" @update:visible="(flag) => this.$emit('update:show', flag)" title="退还">
    <h3 class="sub-title">批次清单</h3>
    <el-table :data="list">
      <el-table-column label="批次号" width="170px">
        <template scope="props">{{props.row.LotCode}}</template>
      </el-table-column>
      <el-table-column label="物料名称" width="260px">
        <template scope="props">
          <p class="no-margin">{{props.row.ProductName}}</p>
          <p class="no-margin">物料编码：{{props.row.ProductCode}}</p>
        </template>
      </el-table-column>
      <el-table-column label="物料品项">
        <template scope="props">
          <el-tag :type="props.row.ConditionName | ConditionColor">{{props.row.ConditionName}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="租赁周期">
        <template scope="props">{{props.row.RentalPeriod}}个月</template>
      </el-table-column>
      <el-table-column label="折扣">
        <template scope="props">{{props.row.DiscountRate * 100}}%</template>
      </el-table-column>
      <el-table-column label="保修">
        <template scope="props">{{props.row.WarrantyMonths}}个月</template>
      </el-table-column>
      <el-table-column label="租金">
        <template scope="props">{{props.row.RentalAmount | amount}}</template>
      </el-table-column>
      <el-table-column label="已租时长">
        <template scope="props">{{props.row.StartDate | fromNow}}</template>
      </el-table-column>
    </el-table>
    <el-form class="dialog-reason" :model="form" ref="form" label-position="left" inline>
      <el-form-item label="退还原因" prop="Notes">
        <el-input type="textarea" v-model="form.Notes" :row="3"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <span class="count">退还数量：{{this.list.length}}个</span>
      <el-button type="primary" @click="handleConfirm()">提交并等待客服联系</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      form: {
        Notes: '',
      },
    }
  },
  computed: {
    Lines() {
      return this.list.map(item => ({ProductLotLineId: item.LineId}))
    },
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    list: {
      type: Array,
      required: true,
    },
  },
  methods: {
    handleConfirm() {
      let form = this.form
      form.Lines = this.Lines
      this.$emit('confirm', 'Return', form)
    },

  },
}
</script>

<style lang="less">
.lease-dialog.lease-repair-form-dialog {
  width: 1101px;
}
</style>



// WEBPACK FOOTER //
// ReturnFormDialog.vue?226a154c